import axios from 'axios'

// 创建 axios 实例
const request = axios.create({
    baseURL: 'http://120.53.241.80:8080', // 修正完整的基础路径
    timeout: 30000, // 延长请求超时时间至30秒
    headers: {
      'Content-Type': 'application/json' // 默认请求头（根据接口要求调整，如 form-data）
    }
  });
  
  // 响应拦截器：统一处理返回数据（简化后续取值）
  request.interceptors.response.use(
    (response) => {
      // 假设接口返回格式为 { code: 200, data: [...], msg: "成功" }
      return response.data; // 直接返回 data 层，后续无需再 .data
    },
    (error) => {
      // 统一捕获错误（如弹窗提示）
      console.error('接口请求失败：', error.message);
      return Promise.reject(error);
    }
  );
  
  export default request;


// WEBPACK FOOTER //
// ./src/api/index.js